const cursorEffect = () => {
  const colors = ["rgb(0, 187, 249)", "rgb(0, 245, 323)", "rgb(252, 254, 255)"];

  const animations = ["fall-1", "fall-2", "fall-3"];

  const rand = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const selectRandom = (items) => items[rand(0, items.length - 1)];

  const calcDistance = (starPos, mousePos) => {
    const diffX = mousePos.x - starPos.x;
    const diffY = mousePos.y - starPos.Y;

    return Math.sqrt(Math.pow(diffX, 2), Math.pow(diffY, 2));
  };

  const originPosition = { x: 0, y: 0 };

  const last = {
    starPosition: originPosition,
    mousePosition: originPosition,
  };

  window.onmousemove = function (event) {
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    const star = document.createElement("span");
    star.className = "cursor-star fa-star fa-solid";
    star.style.left = `${mouseX}px`;
    star.style.top = `${mouseY}px`;
    star.style.color = selectRandom(colors);
    star.style.animationName = selectRandom(animations);
    last.mousePosition = { x: mouseX, y: mouseY };
    if (calcDistance(last.starPosition, last.mousePosition) >= 100) {
      document.body.appendChild(star);
      last.starPosition = last.mousePosition;

      setTimeout(() => document.body.removeChild(star), 1500);
    }
  };
};

export default cursorEffect;
